import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { LaboratoryWaterSampleDto } from "../models/laboratory/laboratory-water-sample.dto";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class LaboratoryWaterSamplesService extends DataService<LaboratoryWaterSampleDto, LaboratoryWaterSampleDto> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'laboratory-water-samples';
    }

    multipleUpdate(samples: LaboratoryWaterSampleDto[] = []): Observable<any> {
        return this.postQuery(`${this.baseUrl()}/multiple-update`, { samples: samples });
    }

    getRequestWaterSamples(requestId: number): Observable<LaboratoryWaterSampleDto[]> {
        return this.getQuery<LaboratoryWaterSampleDto[]>(`${this.baseUrl()}/request-laboratory-water-samples/${requestId}`);
    }
}